import moment from 'moment';

export function VorwerkGewinnspielViewModel(data) {
    var self = this;
    self.type = "VorwerkGewinnspielViewModel";
    self.rootvm = data.rootvm;

    self.moment = moment;
    self.initialized = ko.observable(false);

    self.initialize = function () {
        if (self.offset() == undefined) self.offset(0);
        if (self.limit() == undefined) self.limit(50);

        if (!self.initialized()) {
            self.lookup_entries().then(function () {
                self.initialized(true);
            });
        }
    };

    self.total_count = ko.observable();
    self.confirmed_count = ko.observable();
    self.total_rsvped_people = ko.observable();
    self.total_rsvped_seats = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable();
    self.limit = ko.observable();
    self.entries = ko.observableArray([]);
    self.location_breakdown = ko.observableArray([]);
    self.total_target_seats = ko.computed(function () {
        return self.location_breakdown().reduce(function (sum, loc) {
            return sum + (loc.target || 0);
        }, 0);
    });
    self.search = ko.observable();
    self.filter_location = ko.observable();
    self.order_by_column = ko.observable('inserted');
    self.sort_desc = ko.observable(true);
    self.error = ko.observable();
    self.location_breakdown_visible = ko.observable(false);
    self.toggle_location_breakdown = function () {
        self.location_breakdown_visible(!self.location_breakdown_visible());
    };

    self.search_click = function () {
        self.offset(0);
        self.lookup_entries();
        return false;
    };

    self.lookup_entries = function () {
        self.rootvm.is_busy(true);
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/vorwerk-gewinnspiel',
            type: 'GET',
            data: {
                offset: self.offset(),
                limit: self.limit(),
                search: self.search(),
                location: self.filter_location(),
                order_by_column: self.order_by_column(),
                sort_desc: self.sort_desc(),
            },
            success: function (data) {
                self.entries(data.entries || []);
                self.total_count(data.total_count);
                self.confirmed_count(data.confirmed_count);
                self.total_rsvped_people(data.total_rsvped_people);
                self.total_rsvped_seats(data.total_rsvped_seats);
                self.filtered_count(data.filtered_count);
                self.location_breakdown(data.location_breakdown || []);
            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function () {
                self.rootvm.is_busy(false);
            }
        });
    };

    self.lower_count_label = ko.computed(function () {
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function () {
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count()) {
            return self.filtered_count();
        }
        return parseInt(self.limit()) + parseInt(self.offset());
    });

    self.paging_visible = ko.computed(function () {
        return self.filtered_count() > self.limit();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });

    self.next_button_visible = ko.computed(function () {
        return parseInt(self.offset()) + parseInt(self.limit()) < parseInt(self.filtered_count());
    });

    self.go_left = function () {
        if (self.rootvm.is_busy()) return false;
        self.offset(Math.max(0, parseInt(self.offset()) - parseInt(self.limit())));
        self.lookup_entries();
        return false;
    };

    self.go_right = function () {
        if (self.rootvm.is_busy()) return false;
        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_entries();
        return false;
    };
}
